import React from 'react';

class LoadScreen extends React.Component {
    componentDidUpdate = () => {
        const { progress, complete, onComplete } = this.props;

        if (progress === 100 && !complete) {
            setTimeout(() => {
                if (!complete) {
                    onComplete();
                }
            }, 500);
        }
    };

    render() {
        const { title, progress, text, complete, className } = this.props;

        if (complete) return null;

        return (
            <div id="gamekit-loading-screen" className={`${className}`}>
                <div className="loading-screen-content">
                    <h2 className="loading-text">{title}</h2>
                    <progress className="progress" value={progress} max="100">
                        {progress}
                    </progress>
                    <h2 className="caption">{text}...</h2>
                </div>
            </div>
        );
    }
}

LoadScreen.defaultProps = {
    onComplete: () => {},
    className: '',
    title: 'Game Studio Laden',
    progress: 0,
    text: '',
    complete: false
};

export default LoadScreen;
